import React from 'react'

interface IcEditProps extends React.SVGProps<SVGSVGElement> {
  width?: string
  height?: string
  color?: string
  style?: React.CSSProperties
}

const IcEdit: React.FC<IcEditProps> = ({
  width = '16px',
  height = '16px',
  color = '#007AFF',
  style,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={color}
      style={{ flexShrink: 0, ...style }}
      {...props}
    >
      <path
        d="M9.42592 3.57795L10.5387 2.46517C10.6783 2.32547 10.8441 2.21465 11.0267 2.13904C11.2091 2.06343 11.4047 2.02451 11.6022 2.02451C11.7998 2.02451 11.9954 2.06343 12.1778 2.13904C12.3603 2.21465 12.5261 2.32547 12.6658 2.46517L13.7289 3.52833C14.0108 3.81033 14.1692 4.19274 14.1692 4.59149C14.1692 4.99023 14.0108 5.37265 13.7289 5.65465L12.6161 6.76743M9.42592 3.57795L2.19584 10.8073C1.94621 11.0569 1.79236 11.3865 1.76125 11.7381L1.5793 13.7983C1.56953 13.9078 1.58389 14.0181 1.62139 14.1215C1.65888 14.2249 1.71859 14.3187 1.7963 14.3965C1.87402 14.4743 1.96784 14.534 2.07117 14.5716C2.1745 14.6092 2.28481 14.6238 2.39434 14.614L4.45449 14.4321C4.80669 14.4013 5.13679 14.2474 5.38682 13.9975L12.6161 6.76743M9.42592 3.57795L12.6161 6.76743"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default IcEdit
